// End labels (p10 / p90) under the margin band. Anchored AWAY from each other so they grow apart,
// except at a plot edge where they anchor inward so they never clip (live bug 8e). If the band is
// still too narrow for both (capture review 2026-10-24: "D+4.2D+14.2"), they merge into one range
// label. SVG text can't be measured before paint, so widths are a conservative per-char estimate.

export interface EndLabel {
  x: number
  anchor: 'start' | 'middle' | 'end'
  text: string
}

interface PlotBounds {
  plotLeft: number
  plotRight: number
  svgW: number
}

const FONT_PX = 10
const CHAR_W = 0.65 * FONT_PX // over-estimates digits/signs at 10px so a near-miss still separates
const EDGE_ANCHOR_PX = 16
const MIN_GAP_PX = 4

export const estLabelWidth = (text: string) => text.length * CHAR_W

export function layoutEndLabels(
  left: number,
  right: number,
  loText: string,
  hiText: string,
  { plotLeft, plotRight, svgW }: PlotBounds,
): EndLabel[] {
  const lo: EndLabel = left <= plotLeft + EDGE_ANCHOR_PX
    ? { x: left, anchor: 'start', text: loText }
    : { x: left, anchor: 'end', text: loText }
  const hi: EndLabel = right >= plotRight - EDGE_ANCHOR_PX
    ? { x: right, anchor: 'end', text: hiText }
    : { x: right, anchor: 'start', text: hiText }

  const loEnd = lo.anchor === 'start' ? lo.x + estLabelWidth(loText) : lo.x
  const hiStart = hi.anchor === 'end' ? hi.x - estLabelWidth(hiText) : hi.x
  if (loEnd + MIN_GAP_PX <= hiStart) return [lo, hi]

  const text = `${loText} – ${hiText}`
  const half = estLabelWidth(text) / 2
  const x = Math.min(Math.max((left + right) / 2, half), svgW - half)
  return [{ x, anchor: 'middle', text }]
}
